import { Link } from '~/components/Link'
import ROUTES from '~/shared/constants/routes.const'
import getPaginationWidth from '~/shared/utils/getPaginationWidth.utils'

import { formatThousands } from '~/utils'

import Spacer from './Spacer'

export default function UrlPagePicker({
  isActivePage,
  isDivider,
  onSetPageClick,
  page,
  url,
  baseUrl,
  squreDesign = false,
}: {
  isActivePage: boolean
  isDivider?: boolean
  onSetPageClick?: (newPage: number) => void
  page: number
  url: string
  baseUrl: string
  squreDesign?: boolean
}): React.ReactElement {
  const pageUrl = `${url}/${page + 1}` === baseUrl ? ROUTES.OUR_TEAM : `${url}/${page + 1}`

  if (isDivider) {
    return <Spacer />
  }

  const onClickHandler = (): void => {
    if (onSetPageClick) onSetPageClick(page)
  }

  return (
    <Link
      className={`z-10 relative flex items-center justify-center ${
        squreDesign
          ? `min-w-11.5 h-10 duration-300 ${
              isActivePage
                ? 'bg-gradient-purple-light-top text-white font-medium'
                : 'bg-purple-dark-violet hover:bg-gradient-purple-light-top'
            }`
          : `rounded-full h-6 sm:h-10 ${isActivePage ? 'bg-purple text-white font-medium' : 'hover:bg-purple-light'}`
      } text-sm ${getPaginationWidth(page + 1)}`}
      key={page}
      onClick={onClickHandler}
      to={pageUrl}
    >
      {formatThousands(page + 1)}
    </Link>
  )
}
